import { Component } from 'react';
import styled, { withTheme } from 'styled-components';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import getPDFPageState from '../../selectors/getPDFPageState';
import { MAIN_CONTENT_ANCHOR } from '../../lib/constants';
import { View } from 'foundations-components/components/View';
import { isChirpEnabled } from '../../utils/isChirpEnabled';
import { LeftIcon } from 'foundations-assets/icons/components/LeftIcon';
import { RightIcon } from 'foundations-assets/icons/components/RightIcon';
import { ZoomInIcon } from 'foundations-assets/icons/components/ZoomInIcon';
import { ZoomOutIcon } from 'foundations-assets/icons/components/ZoomOutIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ZOOM_RATIO = 11 / 10;
const PDFControlsContainer = styled.div.withConfig({
  displayName: "PDFControls__PDFControlsContainer"
})(({
  visible,
  $theme
}) => {
  return {
    background: 'rgba(28, 39, 51, 0.9)',
    borderRadius: $theme.borderRadius['200'],
    color: $theme.color['text-core-on-fill-default'],
    display: 'flex',
    alignItems: 'center',
    fontSize: $theme.typography['body-200'].fontSize,
    opacity: visible ? 1 : 0,
    paddingBlock: $theme.space[400],
    paddingInline: $theme.space[300],
    transition: 'opacity 200ms linear'
  };
});
class PDFControls extends Component {
  constructor(...args) {
    super(...args);
    this.previousPage = () => {
      const element = document.getElementById(MAIN_CONTENT_ANCHOR);
      if (element) element.focus();
      const isUngatedToChirp = isChirpEnabled();
      if (isUngatedToChirp) {
        this.props.onChangePageCHIRP({
          leavingPageNumber: this.props.pageNumber,
          enteringPageNumber: this.props.pageNumber - 1
        });
      } else {
        this.props.onPage(this.props.pageIndex - 1);
      }
    };
    this.nextPage = () => {
      const element = document.getElementById(MAIN_CONTENT_ANCHOR);
      if (element) element.focus();
      const isUngatedToChirp = isChirpEnabled();
      if (isUngatedToChirp) {
        this.props.onChangePageCHIRP({
          leavingPageNumber: this.props.pageNumber,
          enteringPageNumber: this.props.pageNumber + 1
        });
      } else {
        this.props.onPage(this.props.pageIndex + 1);
      }
    };
    this.zoomOut = () => {
      this.props.onZoom(this.props.zoom / ZOOM_RATIO);
    };
    this.zoomIn = () => {
      this.props.onZoom(this.props.zoom * ZOOM_RATIO);
    };
  }
  render() {
    const {
      theme,
      visible,
      totalPages
    } = this.props;
    const {
      pageNumber,
      previousPageDisabled,
      nextPageDisabled
    } = getPDFPageState(this.props);
    return (
      /*#__PURE__*/
      // @bend-expect trellis-tokenized
      _jsxs(PDFControlsContainer, {
        $theme: theme,
        visible: visible,
        tabIndex: 0,
        "aria-label": I18n.text('a11y.hiddenPDFControls'),
        children: [/*#__PURE__*/_jsx(View, {
          display: "inline-block",
          marginInline: "300",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "pdf.controls.page",
            options: {
              pageNumber,
              totalPages
            }
          })
        }), /*#__PURE__*/_jsxs(View, {
          display: "inline-block",
          marginInline: "300",
          children: [/*#__PURE__*/_jsx(IconButton, {
            "aria-label": I18n.text('a11y.previousPage'),
            "aria-disabled": previousPageDisabled,
            disabled: previousPageDisabled,
            onClick: this.previousPage,
            marginInlineEnd: "200",
            use: "link-on-dark",
            children: /*#__PURE__*/_jsx(LeftIcon, {})
          }), /*#__PURE__*/_jsx(IconButton, {
            "aria-label": I18n.text('a11y.nextPage'),
            "aria-disabled": nextPageDisabled,
            disabled: nextPageDisabled,
            onClick: this.nextPage,
            use: "link-on-dark",
            children: /*#__PURE__*/_jsx(RightIcon, {})
          })]
        }), /*#__PURE__*/_jsxs(View, {
          display: "inline-block",
          marginInline: "300",
          "aria-hidden": true,
          children: [/*#__PURE__*/_jsx(IconButton, {
            id: "zoom",
            onClick: this.zoomOut,
            marginInlineEnd: "200",
            use: "link-on-dark",
            children: /*#__PURE__*/_jsx(ZoomOutIcon, {})
          }), /*#__PURE__*/_jsx(IconButton, {
            onClick: this.zoomIn,
            use: "link-on-dark",
            children: /*#__PURE__*/_jsx(ZoomInIcon, {})
          })]
        })]
      })
    );
  }
}
PDFControls.defaultProps = {
  visible: true
};
export default withTheme(PDFControls);